import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="py-12 border-t"
      style={{
        background: "var(--ink)",
        borderColor: "rgba(255,255,255,0.06)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap items-center justify-between gap-6">
        <div>
          <div className="text-white font-display text-xl flex items-baseline gap-1.5">
            Conversio
            <span className="font-display-italic text-base">™</span>
          </div>
          <p
            className="text-xs mt-2"
            style={{ color: "rgba(248,241,231,0.5)" }}
          >
            WhatsApp Revenue Multiplier System · Done-for-you
          </p>
        </div>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-whatsapp-btn"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-all hover:scale-[1.03]"
          style={{ background: "var(--whatsapp)" }}
        >
          <MessageCircle size={15} strokeWidth={2.5} />
          Chat on WhatsApp
        </a>
      </div>
      <div
        className="max-w-7xl mx-auto px-6 lg:px-10 mt-8 pt-6 border-t text-xs"
        style={{
          borderColor: "rgba(255,255,255,0.06)",
          color: "rgba(248,241,231,0.4)",
        }}
      >
        © {new Date().getFullYear()} Conversio™. All rights reserved.
      </div>
    </footer>
  );
}
